import React, {Component} from 'react';
import {TITLE} from '../../constants';
import Logo from "../Logo/Logo";
import './sliding.css';
import './header.css';
import './title.css';
import Phone from '../Phone/Phone';
import Benefit from '../Benefit/Benefit';
import AppStore from '../AppStore/AppStore';

class SectionSliding extends Component {
	constructor() {
		super();
		this.state = {width: 1920}
	}

	updateDimensions = () => {
		this.setState({width: document.body.clientWidth});
	};

	componentWillMount() {
		this.updateDimensions();
	}

	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions);
	}

	render() {
		const {width} = this.state;
		return (
			<section className="section">
				<div className="sliding">
					<div className="wrapper">
						<header className="header">
							<Logo/>
							<h1 className="title">{TITLE}</h1>
						</header>
						{width < 768 && <Phone indexImages='4'/>}
						<AppStore/>
					</div>
					<div className="sliding__overflow">
						<div className="wrapper">
							<Benefit/>
						</div>
					</div>
					{width >= 768 && (
						<div className="sliding__wrap">
							<div className="sliding__sticky">
								<Phone opacity='.4' indexImages='5'/>
							</div>
						</div>)}
				</div>
			</section>
		);
	}
}

export default SectionSliding;



// WEBPACK FOOTER //
// ./src/components/SectionSliding/SectionSliding.js